import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Link } from "../design/link";

interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  direction?: "left" | "right";
  className?: string;
}

export default function Breadcrumbs({
  items,
  direction = "left",
  className = "",
}: BreadcrumbsProps) {
  if (!items || items.length === 0) return null;

  const isSingle = items.length === 1;

  return (
    <div className={`w-full mb-6 ${className}`}>
      <nav className="inline-flex items-center gap-2 text-sm/6 text-zinc-500 dark:text-zinc-400">
        {isSingle ? (
          <Link href={items[0].href} className="inline-flex items-center gap-2">
            {direction === "left" && (
              <ChevronLeftIcon className="size-4 fill-zinc-400 dark:fill-zinc-500" />
            )}
            {items[0].label}
          </Link>
        ) : (
          items.map((item, idx) => (
            <span key={idx} className="inline-flex items-center gap-2">
              {idx > 0 && (
                <ChevronRightIcon className="size-4 fill-zinc-400 dark:fill-zinc-500" />
              )}
              {idx === items.length - 1 ? (
                <span className="font-medium text-zinc-700 dark:text-zinc-200">
                  {item.label}
                </span>
              ) : (
                <Link href={item.href}>{item.label}</Link>
              )}
            </span>
          ))
        )}
      </nav>
    </div>
  );
}
